import React, { useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import styled from 'styled-components';
import { doesUserNameExist } from 'api/authRequests';
import { DESIGN_CONFIG, STRING_CONFIG } from 'utils';
import { useDispatch } from 'react-redux';
import { showToast } from 'store/platform/actions';
import Box from '../../../ReusableComponents/Box';

const StyledInput = styled.input`
  background: ${DESIGN_CONFIG.color.neutral.neutral500};
  border: 1px solid ${DESIGN_CONFIG.color.neutral.neutral200};
  border-radius: 6px;
  font-size: ${DESIGN_CONFIG.typography.common.webLabel.fontSize};
  font-weight: ${DESIGN_CONFIG.typography.common.webLabel.fontWeight};
  height: 3rem;
  outline: none;
  padding: 0.875rem 1rem;
  transition: all 0.4s ease;
  width: 100%;
  &:hover,
  &:focus-visible,
  &:focus {
    border: 1px solid ${DESIGN_CONFIG.color.primary.primaryMain};
  }
  &::placeholder {
    color: ${DESIGN_CONFIG.color.text.text200};
    font-size: ${DESIGN_CONFIG.typography.common.webLabel.fontSize};
  }
`;

function UsernameInput({ type, id, placeHolder, setUser, user }) {
  const userNameFormat =
    /^(?!.*[._-]{2})[a-zA-Z0-9](?:[a-zA-Z0-9._-]{0,18}[a-zA-Z0-9])$/;

  const dispatch = useDispatch();

  const [error, setError] = useState('');

  const [val, setVal] = useState('');

  const [loading, setLoading] = useState(false);

  const [showCheck, setShowCheck] = useState(false);

  useEffect(() => {
    const fetchSuggestedUsername = async () => {
      setLoading(true);
      try {
        const { data } = await doesUserNameExist('');
        if (data.success === true) {
          setVal(data.username);

          setUser({ ...user, username: data.username });

          setShowCheck(true);
        }
      } catch (err) {
        dispatch(
          showToast(
            STRING_CONFIG.inPage.toastMessages.txtErrorSomethingWentWrong,
            'error',
            6000,
            false,
            true
          )
        );
      } finally {
        setLoading(false);
      }
    };

    fetchSuggestedUsername();
  }, []);

  const isUserNameUnique = async () => {
    setLoading(true);
    try {
      const { data } = await doesUserNameExist(val);

      const { success, exists } = data;
      if (success) {
        if (exists === 0) {
          setError('');

          setLoading(false);

          setShowCheck(true);

          setUser({ ...user, username: val });
        } else if (exists === 1) {
          setError(STRING_CONFIG.validation.userProfile.username.notAvailable);

          setLoading(false);

          setShowCheck(false);
        }
      }
    } catch (err) {
      setLoading(false);

      setShowCheck(false);

      setVal('');
      if (err.response || err.request) {
        dispatch(
          showToast(
            STRING_CONFIG.inPage.toastMessages.txtErrorSomethingWentWrong,
            'error',
            6000,
            false,
            true
          )
        );
      }
    }
  };

  const handleBlur = () => {
    if (!val) {
      setError(STRING_CONFIG.validation.userProfile.username.empty);

      setLoading(false);

      setShowCheck(false);
      return;
    }
    if (!val.match(userNameFormat)) {
      setError(STRING_CONFIG.validation.userProfile.username.policyFailed);

      setLoading(false);

      setShowCheck(false);
      return;
    }
    isUserNameUnique();
  };

  const handleChange = (e) => {
    setVal(e.target.value);
  };

  return (
    <Box position='relative'>
      <StyledInput
        aria-label='username'
        id={id}
        onBlur={handleBlur}
        onChange={handleChange}
        placeholder={placeHolder}
        type={type}
        value={val}
      />
      {loading ? (
        <CircularProgress
          style={{
            height: 18,
            position: 'absolute',
            right: '1.563rem',
            top: '.75rem',
            width: 18,
          }}
        />
      ) : null}
      {showCheck ? (
        <CheckCircleIcon
          style={{
            color: 'green',
            position: 'absolute',
            right: '1.563rem',
            top: '.75rem',
          }}
        />
      ) : null}
      {error ? (
        <div
          aria-live='assertive'
          role='alert'
          style={{
            color: `${DESIGN_CONFIG.color.error.errorMain}`,
            fontSize: `${DESIGN_CONFIG.typography.common.webLabel.fontSize}`,
            fontWeight: `${DESIGN_CONFIG.typography.common.webLabel.fontWeight}`,
            margin: '2px 0 0 4px',
          }}
        >
          {error}
        </div>
      ) : null}
    </Box>
  );
}

export default UsernameInput;
